import { defineMessages } from '../translate';

/**
 * Words used all over the app (buttons, states, generic errors, counts,
 * relative time). Feature copy lives in the feature's own namespace; only put
 * a string here when it means exactly the same thing everywhere.
 */
export default defineMessages('common', {
  // Actions
  save: 'Save',
  saveChanges: 'Save changes',
  cancel: 'Cancel',
  delete: 'Delete',
  remove: 'Remove',
  close: 'Close',
  edit: 'Edit',
  rename: 'Rename',
  add: 'Add',
  create: 'Create',
  back: 'Back',
  next: 'Next',
  continue: 'Continue',
  done: 'Done',
  apply: 'Apply',
  reset: 'Reset',
  clear: 'Clear',
  retry: 'Retry',
  tryAgain: 'Try again',
  search: 'Search',
  searchPlaceholder: 'Search…',
  filter: 'Filter',
  sort: 'Sort',
  copy: 'Copy',
  copyLink: 'Copy link',
  copied: 'Copied',
  linkCopied: 'Link copied',
  confirm: 'Confirm',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  undo: 'Undo',
  open: 'Open',
  more: 'More',
  moreActions: 'More actions',
  showMore: 'Show more',
  showLess: 'Show less',
  seeAll: 'See all',
  viewAll: 'View all',
  select: 'Select',
  upload: 'Upload',
  download: 'Download',
  send: 'Send',
  invite: 'Invite',
  archive: 'Archive',
  restore: 'Restore',
  leave: 'Leave',
  skip: 'Skip',
  dismiss: 'Dismiss',
  enable: 'Enable',
  disable: 'Disable',
  connect: 'Connect',
  disconnect: 'Disconnect',
  manage: 'Manage',
  settings: 'Settings',
  help: 'Help',
  learnMore: 'Learn more',
  upgrade: 'Upgrade',
  signIn: 'Sign in',
  signOut: 'Sign out',
  // States
  // For aria-labels on skeletons only — visible "Loading…" text is banned (glossary lint).
  loading: 'Loading',
  saving: 'Saving…',
  saved: 'Saved',
  deleting: 'Deleting…',
  sending: 'Sending…',
  creating: 'Creating…',
  uploading: 'Uploading…',
  updating: 'Updating…',
  on: 'On',
  off: 'Off',
  enabled: 'Enabled',
  disabled: 'Disabled',
  optional: 'optional',
  required: 'Required',
  none: 'None',
  noneDash: '—',
  unassigned: 'Unassigned',
  untitled: 'Untitled',
  unknown: 'Unknown',
  you: 'You',
  youSuffix: '(you)',
  new: 'New',
  beta: 'Beta',
  comingSoon: 'Coming soon',
  noResults: 'No results',
  nothingHereYet: 'Nothing here yet',
  // Errors / toasts
  somethingWentWrong: 'Something went wrong',
  somethingWentWrongRetry: 'Something went wrong. Please try again.',
  actionFailed: 'Action failed.',
  failedToLoad: "Couldn't load this",
  failedToSave: "Couldn't save",
  changesSaved: 'Changes saved',
  offline: "You're offline",
  noPermission: "You don't have permission to do that",
  // Dates (relative). Absolute dates go through shared/lib/format-locale.
  today: 'Today',
  tomorrow: 'Tomorrow',
  yesterday: 'Yesterday',
  justNow: 'just now',
  minutesAgoShort: '{count}m ago',
  hoursAgoShort: '{count}h ago',
  daysAgoShort: '{count}d ago',
  // Counts
  tasks: { one: '{count} task', other: '{count} tasks' },
  projects: { one: '{count} project', other: '{count} projects' },
  members: { one: '{count} member', other: '{count} members' },
  people: { one: '{count} person', other: '{count} people' },
  comments: { one: '{count} comment', other: '{count} comments' },
  files: { one: '{count} file', other: '{count} files' },
  items: { one: '{count} item', other: '{count} items' },
  selected: { one: '{count} selected', other: '{count} selected' },
  days: { one: '{count} day', other: '{count} days' },
  hours: { one: '{count} hour', other: '{count} hours' },
  minutes: { one: '{count} minute', other: '{count} minutes' },
  moreCount: '+{count} more',
  // Language picker
  language: 'Language',
} as const);
